/* eslint-disable @typescript-eslint/no-namespace */
import type { Utility } from '../../types/utility';

export namespace Paper {
  /** Paper Component Variant Keys */
  export type VariantKeys = 'default' | 'raised' | 'raisedLow';

  /** Paper Component Variants */
  export type Variants = {
    [Key in VariantKeys]: Utility.CSSProperties;
  };

  /** Paper Component Variant Modes */
  export type VariantModes = Utility.VariantKeyModes<VariantKeys>;
}

const basePaper: Utility.VariantCSSKeys<Paper.VariantKeys> = {
  default: {
    background: 'white',
    borderStyle: 'solid',
    borderWidth: '1px',
    borderColor: 'coolGrey.10',
    borderRadius: 'r8',
    padding: 's40',
  },
  raised: {
    background: 'white',
    borderStyle: 'solid',
    borderWidth: '1px',
    borderColor: 'coolGrey.10',
    borderRadius: 'r8',
    boxShadow: '20',
    padding: 's40',
  },
  raisedLow: {
    background: 'white',
    borderStyle: 'solid',
    borderWidth: '1px',
    borderColor: 'coolGrey.10',
    borderRadius: 'r8',
    boxShadow: '10',
    padding: 's40',
  },
};

const paper: Utility.VariantKeyModes<Paper.VariantKeys> = {
  products: {
    chart: basePaper,
    chartblog: basePaper,
    co: basePaper,
    edu: basePaper,
    scale: basePaper,
    spark: basePaper,
  },
};

export const paperVariants = Object.keys(basePaper) as Paper.VariantKeys[];

export default paper;
